import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.css';

const Button = ({ text, isDisabled, classes, onClick }) => {
    const handleClick = useCallback(() => {
        if (!isDisabled) {
            onClick();
        }
    }, [isDisabled, onClick]);

    return (
        <input
            type="button"
            value={text}
            className={classNames({
                'c-button': !isDisabled,
                'c-button--disabled': isDisabled,
                [classes]: !!classes,
            })}
            onClick={handleClick}
        />
    );
};

Button.propTypes = {
    text: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool.isRequired,
    classes: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default React.memo(Button);
